module.exports = __webpack_public_path__ + "img/02.sunset-light.dd509f9d.svg";